import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useDeleteMeetingSummary } from "../../hooks/useManagement";

export const DeleteMeetingModal = ({ show, handleClose, Meeting }) => {
  const [button] = useState(false);
  const idMeeting = Meeting;
  const { mutateAsync: DeleteMeeting } = useDeleteMeetingSummary();
  const handleDeleteMeeting = async () => {
    await DeleteMeeting({ meeting_id: Meeting });
  };
  return (
    <BootstrapModal
      modaltitle="حذف صورت جلسه"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy size="15px">
            آیا از حذف این صورت جلسه مطمئن هستید؟
          </Typogaphy>
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleDeleteMeeting();
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
